<template>
  <div class="avatar-wrapper" @click="random()">
    <svg
      class="avatar"
      width="247px"
      height="338px"
      viewBox="0 0 247 338"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <faceColors :skinTone="skinTone" :avatarId="avatarId" />
        <path
          id="eye-right"
          d="M149.081248,144 C154.290415,144 160,139.970563 160,135 C160,130.029437 154.290415,126 149.081248,126 C143.872082,126 138,130.029437 138,135 C138,139.970563 143.872082,144 149.081248,144 Z"
        />
        <path
          id="eye-left"
          d="M96.0812483,144 C101.290415,144 107,139.970563 107,135 C107,130.029437 101.290415,126 96.0812483,126 C90.8720816,126 85,130.029437 85,135 C85,139.970563 90.8720816,144 96.0812483,144 Z"
        />
        <filter
          id="filter-10"
          x="-95.5%"
          y="-83.3%"
          width="290.9%"
          height="333.3%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dx="0"
            dy="6"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.419582201   0 0 0 0 0.134266304   0 0 0 0 0  0 0 0 0.529938811 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>

        <!-- <linearGradient
          x1="50%"
          y1="-45.8489962%"
          x2="50%"
          y2="93.4731838%"
          id="shadow-nose"
        >
          <stop stop-color="#B65F43" offset="0%"></stop>
          <stop stop-color="#AB5431" offset="100%"></stop>
        </linearGradient> -->
        <!-- <path
          d="M110,170 C110.228208,170.418244 110.889472,170.713496 111.564223,170.837407 C112.654363,171.010352 114.177413,171.417529 116.854685,171.45982 C120.128859,171.45982 120.515145,172.331717 122.348954,172.331717 L122.969934,172.331717 L122.969934,172.331717 L122.969934,176 L122.969934,176 C118.503016,175.834999 120.625832,174.269421 112.334662,173.282556 C110.93215,172.783959 110,172.419633 110,170 Z M136,170 C136,172.419741 135.069358,172.784084 133.669116,173.282703 C125.39136,174.269612 127.48067,175.834992 123.020979,176 L123.020979,176 L123.020979,172.331822 L123.020979,172.331822 L123.671027,172.331822 C125.501868,172.331822 125.88753,171.459885 129.156406,171.459885 C131.829346,171.417592 133.349932,171.010398 134.438308,170.837444 C135.111967,170.713528 135.772161,170.418263 136,170 Z"
          id="path-2"          :fill="`url(#shadow-nose${avatarId})`"
        ></path>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Combined-Shape-Copy-225">
            <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-2"></use>
            <use fill="url(#linearGradient-1)" fill-rule="evenodd" xlink:href="#path-2"></use>
        </g>
    </g> -->
      </defs>

      <defs>
        <filter
          id="filter-14"
          x="-38.5%"
          y="-133.3%"
          width="176.9%"
          height="433.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="3"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.810943161   0 0 0 0 0.197447031   0 0 0 0 0  0 0 0 1 0"
            type="matrix"
            in="shadowBlurOuter1"
          />
        </filter>
        <linearGradient
          :id="`nose-drop-shadow${avatarId})`"
          x1="50%"
          y1="-45.8489962%"
          x2="50%"
          y2="93.4731838%"
        >
          <stop stop-color="#FFE1BC" offset="0%" />
          <stop stop-color="#C76F3A" offset="100%" />
        </linearGradient>
      </defs>

      <!-- hair back -->
      <backHair
        :hairStyle="hairStyleB"
        :class="`avatar__hair--${hairColor} back`"
      />
      <path
        d="M247,338 C233.243006,237.201315 191.707394,226 123.500509,226 C55.2936227,226 12.1756489,235.197845 0,338 C246.359585,337.266247 0.285034156,337.481799 247,338 Z"
        class="avatar__shirt"
      />

      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M122,173 C131.124202,173 142.681818,176.655964 148.511176,182.763221 C153.972984,188.485407 154,196.377936 154,204.900176 C154,205.245489 153.994496,205.57815 153.983571,205.898522 L154,205.898462 C153.738375,216.817516 152.005467,226.984492 148.801277,236.39939 C144.171405,244.288511 142.190473,245.771977 140.037105,247.045405 C131.682952,251.985763 125.670504,254.293997 121.999759,253.970109 C118.330593,254.294418 112.31781,251.986213 103.962895,247.045405 C101.809527,245.771977 99.8285951,244.288511 95.1987228,236.39939 C91.9945328,226.984492 90.2616252,216.817516 90,205.898462 L90,205.898462 L90.0164288,205.898522 C90.0055038,205.57815 90,205.245489 90,204.900176 C90,196.816737 90.1491752,188.38492 95.1205904,182.763221 C100.984452,176.13234 112.435621,173 122,173 Z"
          :fill="`url(#front-face${avatarId})`"
          transform="translate(122.000000, 213.500000) scale(1, -1) translate(-122.000000, -213.500000) "
        />

        <path
          d="M122.024772,175.030127 C125.692601,174.703786 131.700383,177.028667 140.048117,182.00477 C142.199787,183.287385 144.179157,184.781554 148.805378,192.727592 C152.00704,202.210415 153.738581,212.450742 154,223.448574 L154,223.448574 L153.98358,223.448396 C153.994499,223.771115 154,224.106215 154,224.454062 L154,224.454062 L153.999633,225.387877 C153.995677,229.095029 153.949564,232.671896 153.418601,235.991347 L153.332166,235.993375 L153.332166,235.993375 L152.258184,236 C124.970493,236 101.613483,223.185257 92.0001241,205.027922 C92.8234891,200.794733 93.9056377,196.69487 95.2451003,192.727592 C99.6360894,185.18559 101.642555,183.456015 103.675105,182.202884 L104.00236,182.00477 C112.349924,177.028769 118.35763,174.703882 122.024772,175.030127 Z"
          fill-opacity="0.8"
          :fill="`url(#neck-shadow${avatarId})`"
        />
        <path
          d="M122.5,48 C141.746364,48 166.125711,55.7275623 178.422012,68.6363906 C189.943013,80.7312983 190,97.4136311 190,115.426977 C190,122.673983 188.855464,129.653957 186.737106,136.196371 C185.646565,152.876128 183.201334,168.428773 179.399627,182.853955 C178.552737,184.533012 176.506428,188.232551 172.919218,191.40384 C151.775278,210.096234 135.031314,218.935544 122.687326,217.92177 C110.343627,218.935148 93.5999402,210.095815 72.4564744,191.40384 C68.8692643,188.232551 66.8229552,184.533012 65.9760655,182.853955 C62.2814695,168.835198 59.8679911,153.751613 58.7356304,137.603201 C56.3152953,130.657764 55,123.195806 55,115.426977 C55,98.3411202 55.3146665,80.5188999 65.8012454,68.6363906 C78.1703282,54.6207862 102.325139,48 122.5,48 Z"
          :fill="`url(#front-face${avatarId})`"
        />
        <path
          d="M63.2117589,86.9643906 C62.1514101,95.8063681 61.8033859,103.807409 62.1676863,110.967512 C63.3240012,136.030492 66.1686735,158.936313 70.7017035,179.684977 C71.4608514,181.500593 73.2951529,185.501017 76.5107108,188.930229 C83.7976735,196.701366 90.2951611,203.058872 96.0031737,208.002749 C90.8047667,204.814353 84.9775686,200.818615 78.5211921,196.014866 C72.9315207,191.855974 70.0711507,189.668678 66.250486,182.260956 C62.8497604,167.645299 59.1461765,145.492122 55.1397342,115.801424 C54.7754338,109.147189 55.1234579,101.71143 56.1838067,93.4941477 C57.0732354,83.0650228 62.3784974,74.1587367 67.9265489,67.9970101 C65.664882,73.4259632 63.8519287,79.948638 63.2117589,86.9643906 Z"
          fill-opacity="0.5"
          :fill="`url(#face-highligth${avatarId})`"
        />
        <path
          d="M149,115 C157.318195,158.144778 163.031738,181.478652 166.14063,185.001619 C191.76094,214.034318 199.598286,218.247326 169.959961,195.17894 C164.323267,190.791734 162.587,188.98338 158.792687,181.567726 C155.415417,166.93642 152.151188,144.747178 149,115 Z"
          fill-opacity="0.5"
          :fill="`url(#face-shadow${avatarId})`"
          transform="scale(-1, 1)"
        />

        <path
          d="M183,149.384377 L183,124.102874 C183,120.807365 185.027204,118.773074 189.081612,118 C196.445973,118.22077 196.699587,122.013901 197.534146,125.524808 C198.368704,129.035714 198.267389,131.912302 195.677851,139.513368 C194.688439,142.384825 192.636914,146.6337 189.654357,151.188022 C188.514913,152.927939 187.169105,153.414814 185.616934,152.648649 C184.242157,152.11577 183.369846,150.874062 183,148.923524"
          :fill="`url(#ear-colors${avatarId})`"
        />
        <path
          d="M47,152.384377 L47,127.102874 C47,123.807365 49.027204,121.773074 53.0816119,121 C60.4459732,121.22077 60.6995872,125.013901 61.5341457,128.524808 C62.3687043,132.035714 62.2673893,134.912302 59.6778513,142.513368 C58.6884386,145.384825 56.6369138,149.6337 53.6543574,154.188022 C52.5149126,155.927939 51.1691048,156.414814 49.616934,155.648649 C48.2421569,155.11577 47.3698456,153.874062 47,151.923524"
          :fill="`url(#ear-colors${avatarId})`"
          transform="translate(54.500000, 138.500000) scale(-1, 1) translate(-54.500000, -138.500000) "
        />

        <!-- Eye right TODO: CLEAN UP-->
        <g
          id="eyer"
          transform="translate(90.000000, 130.000000) scale(.95) rotate(6.000000) translate(-24.000000, -14.000000) translate(10.000000, 7.000000)"
        >
          <g id="Path-4" opacity="0.6">
            <use
              fill="black"
              fill-opacity="1"
              filter="url(#filter-2)"
              xlink:href="#path-1"
            />
            <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1" />
          </g>
          <circle
            id="Oval"
            fill="url(#radialGradient-3)"
            cx="16.5"
            cy="7.5"
            r="6.5"
          />
          <circle id="Oval" fill="#000000" cx="16.5" cy="7.5" r="3.5" />
          <path
            id="Path-4"
            d="M5.07460706,8.10435876 C5.83276019,6.37323889 6.99180696,4.95686358 8.55174737,3.85523283 C10.8798134,2.21115137 13.5563939,1.36341247 15.7267154,1.10737499 C21.490559,0.427402008 25.1092501,3.76953014 25.5945988,4.45215691 C25.8522433,4.81452535 26.2790066,5.70932127 26.9126638,7 C26.5073363,6.76767398 24.6930369,4.1093674 21.7027543,3.07944696 C19.5170848,2.32665334 15.7596028,2.35969451 12.8814323,3.07944696 C10.995237,3.55113328 8.97086394,4.69799165 7.68714926,5.92777679 C5.81729532,7.92838211 5.81729532,9.37485071 7.12041729,12 C6.22807176,11.3476263 5.57039767,10.4421122 5.04400455,9.19925526 C4.97147635,9.02801029 4.99342009,8.28973607 5.07460706,8.10435876 Z"
            fill="#002733"
            opacity="0.539178757"
          />
          <path
            id="Path-0"
            d="M14.1965543,3.40773676 C14.0097157,3.62831365 13.863699,3.8686664 13.8731194,3.94016374 C13.8809698,4.0131823 13.623478,4.03295815 13.3000431,3.98427912 C12.818031,3.91126056 12.6468931,3.9599396 12.3532896,4.25049261 C12.1538905,4.4482512 11.9984533,4.78900447 12.0000116,5.02327234 C12.0031635,5.25297655 12.1460401,5.57851762 12.318748,5.74585182 C12.491456,5.91318601 12.8274514,6.05313825 13.0645323,6.05618069 C13.3016132,6.06074435 13.601497,5.95425895 13.7318129,5.82191281 C13.8621289,5.68956668 14.0207062,5.58308128 14.0850792,5.58764494 C14.1494521,5.59068738 14.2028346,5.69565156 14.2028346,5.82191281 C14.2028346,5.94817407 14.3268703,6.32847906 14.4775972,6.6677111 C14.6283241,7.00694315 14.8763955,7.31422958 15.0271224,7.35226008 C15.1778494,7.38876936 15.4431916,7.35073886 15.6158995,7.26707176 C15.7886074,7.18340467 16.0712204,6.89285166 16.2439283,6.62055329 C16.4150662,6.34825492 16.5563727,5.86907063 16.5579428,5.55569932 C16.5579428,5.24232801 16.4872895,4.81486521 16.4009355,4.60493686 C16.3145816,4.39652972 15.9785861,3.94776984 15.6551513,3.60853779 C15.3317164,3.27082696 14.9470488,2.99700737 14.8026021,3.0000247 C14.6565854,3.00461347 14.3833929,3.18868108 14.1965543,3.40773676 Z M19.5630608,8.28476791 C19.2773077,8.4977387 19.2176449,8.64681826 19.3008588,8.94041371 C19.3605215,9.15034206 19.633714,9.60670804 19.9069066,9.95658863 C20.1800991,10.3064692 20.5631967,10.6669983 20.7578857,10.7552291 C20.9525746,10.8449811 21.3937649,10.9179996 21.7391807,10.9179996 C22.2416038,10.9179996 22.4315826,10.8343325 22.6859342,10.4996642 C22.8617823,10.2699599 23.0030888,9.92768545 22.9999487,9.73905418 C22.9983786,9.55042291 22.9245852,9.2598699 22.8382312,9.0925357 C22.7518773,8.92520151 22.4519935,8.6574668 22.1709506,8.4977387 C21.8899077,8.33801061 21.2728693,8.16307031 20.7971375,8.1083064 C20.0984554,8.02920296 19.8629446,8.0626698 19.5630608,8.28476791 Z M17.6585633,11.2602741 C17.6585633,11.3652383 17.7260764,11.6907794 17.8077202,11.9828536 C17.8893639,12.2749278 18.0824828,12.6400206 18.2379199,12.7906214 C18.4184782,12.9686041 18.6477087,13.037059 18.8737991,12.9807739 C19.11088,12.9229675 19.2254953,12.7830153 19.2223551,12.5533111 C19.219215,12.3646798 19.1297209,12.1091149 19.0245261,11.9828536 C18.9177612,11.8565923 18.6021767,11.6010274 18.3227038,11.4123961 C18.043231,11.2237648 17.7794589,11.0701216 17.7354968,11.0701216 C17.6915348,11.0701216 17.6569932,11.15531 17.6585633,11.2602741 Z"
            fill="#FFFFFF"
            fill-rule="nonzero"
          />
          <path
            id="Path-0"
            d="M12.3149171,0.497997785 C10.2731412,0.995995571 8.37658854,1.7745161 6.90630529,3.04052613 C5.43602204,4.30653616 4.89900006,5.35754402 3.96528046,6.03336097 C3.2783341,6.43629923 2.67236988,6.9104191 2.31820038,7.05261588 C1.96403088,7.19481266 1.29754827,7.39205335 0.837127914,7.4914382 L0,7.67185992 C5.35278907,11.1075176 6.96104058,12.0570251 7.02704489,11.9973942 C7.09304921,11.9377633 6.82903194,11.5601009 6.44105535,11.1564455 C6.05307876,10.7543191 5.56368091,10.0632122 5.35439893,9.62133188 L4.97447164,8.81860813 C5.48962728,7.69326588 6.53922465,5.47185293 8.83813894,3.97539381 C11.1370532,2.47893468 13.4848238,1.69550878 15.5579428,1.60819774 C17.2642597,1.53633485 19.3702879,1.70265322 22,2.49442435 C24.6297121,3.28619549 25.9568951,5.22130211 25.9794332,5.18307717 C26.0019712,5.14332323 25.3547067,3.57982694 24.0799115,2.49442435 C22.8051162,1.40902177 20.3531757,0.291783919 19.0976532,0.16601061 C17.4404649,7.38548112e-13 14.356693,1.25784105e-12 12.3149171,0.497997785 Z"
            fill="#000000"
            fill-rule="nonzero"
          />
        </g>
        <g
          id="eyel"
          transform="translate(155.000000, 130.000000)  scale(-.95, .95) rotate(6.000000) translate(-24.000000, -14.000000) translate(10.000000, 7.000000)"
        >
          <g id="Path-4" opacity="0.6">
            <use
              fill="black"
              fill-opacity="1"
              filter="url(#filter-2)"
              xlink:href="#path-1"
            />
            <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1" />
          </g>
          <circle
            id="Oval"
            fill="url(#radialGradient-3)"
            cx="16.5"
            cy="7.5"
            r="6.5"
          />
          <circle id="Oval" fill="#000000" cx="16.5" cy="7.5" r="3.5" />
          <path
            id="Path-4"
            d="M5.07460706,8.10435876 C5.83276019,6.37323889 6.99180696,4.95686358 8.55174737,3.85523283 C10.8798134,2.21115137 13.5563939,1.36341247 15.7267154,1.10737499 C21.490559,0.427402008 25.1092501,3.76953014 25.5945988,4.45215691 C25.8522433,4.81452535 26.2790066,5.70932127 26.9126638,7 C26.5073363,6.76767398 24.6930369,4.1093674 21.7027543,3.07944696 C19.5170848,2.32665334 15.7596028,2.35969451 12.8814323,3.07944696 C10.995237,3.55113328 8.97086394,4.69799165 7.68714926,5.92777679 C5.81729532,7.92838211 5.81729532,9.37485071 7.12041729,12 C6.22807176,11.3476263 5.57039767,10.4421122 5.04400455,9.19925526 C4.97147635,9.02801029 4.99342009,8.28973607 5.07460706,8.10435876 Z"
            fill="#002733"
            opacity="0.539178757"
          />
          <path
            id="Path-0"
            d="M14.1965543,3.40773676 C14.0097157,3.62831365 13.863699,3.8686664 13.8731194,3.94016374 C13.8809698,4.0131823 13.623478,4.03295815 13.3000431,3.98427912 C12.818031,3.91126056 12.6468931,3.9599396 12.3532896,4.25049261 C12.1538905,4.4482512 11.9984533,4.78900447 12.0000116,5.02327234 C12.0031635,5.25297655 12.1460401,5.57851762 12.318748,5.74585182 C12.491456,5.91318601 12.8274514,6.05313825 13.0645323,6.05618069 C13.3016132,6.06074435 13.601497,5.95425895 13.7318129,5.82191281 C13.8621289,5.68956668 14.0207062,5.58308128 14.0850792,5.58764494 C14.1494521,5.59068738 14.2028346,5.69565156 14.2028346,5.82191281 C14.2028346,5.94817407 14.3268703,6.32847906 14.4775972,6.6677111 C14.6283241,7.00694315 14.8763955,7.31422958 15.0271224,7.35226008 C15.1778494,7.38876936 15.4431916,7.35073886 15.6158995,7.26707176 C15.7886074,7.18340467 16.0712204,6.89285166 16.2439283,6.62055329 C16.4150662,6.34825492 16.5563727,5.86907063 16.5579428,5.55569932 C16.5579428,5.24232801 16.4872895,4.81486521 16.4009355,4.60493686 C16.3145816,4.39652972 15.9785861,3.94776984 15.6551513,3.60853779 C15.3317164,3.27082696 14.9470488,2.99700737 14.8026021,3.0000247 C14.6565854,3.00461347 14.3833929,3.18868108 14.1965543,3.40773676 Z M19.5630608,8.28476791 C19.2773077,8.4977387 19.2176449,8.64681826 19.3008588,8.94041371 C19.3605215,9.15034206 19.633714,9.60670804 19.9069066,9.95658863 C20.1800991,10.3064692 20.5631967,10.6669983 20.7578857,10.7552291 C20.9525746,10.8449811 21.3937649,10.9179996 21.7391807,10.9179996 C22.2416038,10.9179996 22.4315826,10.8343325 22.6859342,10.4996642 C22.8617823,10.2699599 23.0030888,9.92768545 22.9999487,9.73905418 C22.9983786,9.55042291 22.9245852,9.2598699 22.8382312,9.0925357 C22.7518773,8.92520151 22.4519935,8.6574668 22.1709506,8.4977387 C21.8899077,8.33801061 21.2728693,8.16307031 20.7971375,8.1083064 C20.0984554,8.02920296 19.8629446,8.0626698 19.5630608,8.28476791 Z M17.6585633,11.2602741 C17.6585633,11.3652383 17.7260764,11.6907794 17.8077202,11.9828536 C17.8893639,12.2749278 18.0824828,12.6400206 18.2379199,12.7906214 C18.4184782,12.9686041 18.6477087,13.037059 18.8737991,12.9807739 C19.11088,12.9229675 19.2254953,12.7830153 19.2223551,12.5533111 C19.219215,12.3646798 19.1297209,12.1091149 19.0245261,11.9828536 C18.9177612,11.8565923 18.6021767,11.6010274 18.3227038,11.4123961 C18.043231,11.2237648 17.7794589,11.0701216 17.7354968,11.0701216 C17.6915348,11.0701216 17.6569932,11.15531 17.6585633,11.2602741 Z"
            fill="#FFFFFF"
            fill-rule="nonzero"
          />
          <path
            id="Path-0"
            d="M12.3149171,0.497997785 C10.2731412,0.995995571 8.37658854,1.7745161 6.90630529,3.04052613 C5.43602204,4.30653616 4.89900006,5.35754402 3.96528046,6.03336097 C3.2783341,6.43629923 2.67236988,6.9104191 2.31820038,7.05261588 C1.96403088,7.19481266 1.29754827,7.39205335 0.837127914,7.4914382 L0,7.67185992 C5.35278907,11.1075176 6.96104058,12.0570251 7.02704489,11.9973942 C7.09304921,11.9377633 6.82903194,11.5601009 6.44105535,11.1564455 C6.05307876,10.7543191 5.56368091,10.0632122 5.35439893,9.62133188 L4.97447164,8.81860813 C5.48962728,7.69326588 6.53922465,5.47185293 8.83813894,3.97539381 C11.1370532,2.47893468 13.4848238,1.69550878 15.5579428,1.60819774 C17.2642597,1.53633485 19.3702879,1.70265322 22,2.49442435 C24.6297121,3.28619549 25.9568951,5.22130211 25.9794332,5.18307717 C26.0019712,5.14332323 25.3547067,3.57982694 24.0799115,2.49442435 C22.8051162,1.40902177 20.3531757,0.291783919 19.0976532,0.16601061 C17.4404649,7.38548112e-13 14.356693,1.25784105e-12 12.3149171,0.497997785 Z"
            fill="#000000"
            fill-rule="nonzero"
          />
        </g>
        <g
          transform="translate(149.000000, 130.000000) scale(-1, -1) translate(-149.000000, -135.000000) "
        />
        <g transform="translate(45.000000, 48.000000)">
          <path
            id="path-13"
            d="M64,123 C64.2282081,123.418244 64.8894721,123.713496 65.5642226,123.837407 C66.6543626,124.010352 68.1774127,124.417529 70.8546848,124.45982 C74.128859,124.45982 74.5151451,125.331717 76.3489536,125.331717 L76.9699342,125.331717 L76.9699342,125.331717 L76.9699342,129 L76.9699342,129 C72.5030158,128.834999 74.6258323,127.269421 66.3346619,126.282556 C64.93215,125.783959 64,125.419633 64,123 Z M90,123 C90,125.419741 89.0693582,125.784084 87.6691156,126.282703 C79.3913603,127.269612 81.4806695,128.834992 77.0209786,129 L77.0209786,129 L77.0209786,125.331822 L77.0209786,125.331822 L77.6710271,125.331822 C79.5018684,125.331822 79.8875296,124.459885 83.1564061,124.459885 C85.8293464,124.417592 87.3499322,124.010398 88.4383083,123.837444 C89.1119671,123.713528 89.7721611,123.418263 90,123 Z"
          />
          <use
            :fill="`url(#nose-drop-shadow${avatarId})`"
            fill-rule="evenodd"
            xlink:href="#path-13"
          />
        </g>
        <!-- nose -->
        <path
          d="M123.25,140 C123.249874,140.028225 123.249751,140.058613 123.249629,140.091162 L136,142.504357 C135.97819,144.606766 135.85203,147.862189 135.621519,152.270627 C134.008536,166.118605 129.308914,172.648005 123.250554,172.986128 C123.249996,172.989962 123.249998,172.994981 123.25,173 C123.166501,173 123.083246,172.998858 123.000237,172.996571 L122.97175,172.997298 L122.97175,172.997298 L122.75,173 C122.750002,172.994902 122.750004,172.989804 122.750006,172.984707 C116.691605,172.648826 111.991553,166.121335 110.378481,152.276548 C110.14797,147.86937 110.02181,144.614877 110,142.513069 L122.75,140.095 L122.75,140 L123,140.047 L123.25,140 Z"
          fill-opacity="0.8"
          :fill="`url(#nose-colors${avatarId})`"
          transform="translate(123.000000, 156.500000) scale(1, -1) translate(-123.000000, -156.500000) "
        />

        <g
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          transform="translate(104.000000, 165.000000)"
        >
          <path
            :id="`shadow-nose${avatarId}`"
            d="M6,3 C6.22820811,3.41824406 6.88947208,3.71349588 7.56422264,3.83740699 C8.65436259,4.01035242 10.1774127,4.41752873 12.8546848,4.45981999 C16.128859,4.45981999 16.5151451,5.33171745 18.3489536,5.33171745 L18.9699342,5.33171745 L18.9699342,5.33171745 L18.9699342,9 L18.9699342,9 C14.5030158,8.83499923 16.6258323,7.26942064 8.33466195,6.28255562 C6.93215004,5.78395885 6,5.41963278 6,3 Z M32,3 C32,5.41974114 31.0693582,5.78408352 29.6691156,6.28270262 C21.3913603,7.26961183 23.4806695,8.83499185 19.0209786,9 L19.0209786,9 L19.0209786,5.33182186 L19.0209786,5.33182186 L19.6710271,5.33182186 C21.5018684,5.33182186 21.8875296,4.45988537 25.1564061,4.45988537 C27.8293464,4.41759221 29.3499322,4.01039767 30.4383083,3.83744449 C31.1119671,3.71352784 31.7721611,3.41826279 32,3 Z"
          />
          <g>
            <use
              fill="black"
              fill-opacity="1"
              :filter="`url(#nose-shadow-drop${avatarId})`"
              :xlink:href="`#shadow-nose${avatarId}`"
            />
            <use
              :fill="`url(#nose-shadow-grad${avatarId})`"
              fill-rule="evenodd"
              :xlink:href="`#shadow-nose${avatarId}`"
            />
          </g>
        </g>
        <g transform="translate(54.000000, 118.000000)">
          <!-- TODO: update mask variables -->
          <defs>
            <radialGradient
              id="radialGradient-1"
              cx="40.8438126%"
              cy="31.5992318%"
              fx="40.8438126%"
              fy="31.5992318%"
              r="77.37932%"
              gradientTransform="translate(0.408438,0.315992),scale(0.987523,1.000000),rotate(90.000000),translate(-0.408438,-0.315992)"
            >
              <stop stop-color="#B7F0FF" offset="0%" />
              <stop
                stop-color="#5DE8D9"
                stop-opacity="0.453452797"
                offset="32.5274493%"
              />
              <stop stop-color="#0EA780" stop-opacity="0" offset="100%" />
            </radialGradient>
            <path
              id="path-2"
              d="M70.2173421,44.014941 L70.3933152,44.00571 C73.3615854,43.8885801 78.1596057,45.5734615 84.9449318,49.0603542 C86.7828096,49.9869351 88.5047488,51.0663462 92.9047019,56.8066872 C96.3786343,63.657225 98.7519247,71.054996 99.9154404,79 L99.8410791,78.5103425 C99.8483267,78.5550593 99.855434,78.6001009 99.8624008,78.645469 L99.9154404,79 C99.9260121,79.0973104 99.938388,79.196585 99.9501455,79.2973083 C100.689315,85.629563 97.8114268,91.1725664 92.9047019,95.4243048 C87.4808746,99.9621618 79.660083,102.999928 70.3933152,102.999928 C60.6794933,102.999928 51.1480885,100.351228 45.725482,95.4243048 C41.2932655,91.2472311 39.7827051,85.3035215 40.4838154,79.2973083 L40.5212619,79 L40.5512655,78.7812834 C40.5655442,78.6830352 40.5804659,78.5862837 40.5960268,78.4910114 L40.5185205,79 C41.6820363,71.054996 44.0553267,63.657225 47.529259,56.8066872 C51.9292122,51.0663462 53.6511513,49.9869351 55.4890291,49.0603542 C62.40843,45.5034737 67.2627422,43.8216693 70.2173421,44.014941 Z"
            />
            <filter
              id="filter-3"
              x="-9.2%"
              y="-9.3%"
              width="118.4%"
              height="118.6%"
              filterUnits="objectBoundingBox"
            >
              <feGaussianBlur
                stdDeviation="3"
                in="SourceAlpha"
                result="shadowBlurInner1"
              />
              <feOffset
                dx="0"
                dy="-4"
                in="shadowBlurInner1"
                result="shadowOffsetInner1"
              />
              <feComposite
                in="shadowOffsetInner1"
                in2="SourceAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
                result="shadowInnerInner1"
              />
              <feColorMatrix
                values="0 0 0 0 0.358667346   0 0 0 0 0.358667346   0 0 0 0 0.358667346  0 0 0 0.5 0"
                type="matrix"
                in="shadowInnerInner1"
              />
            </filter>
          </defs>
          <g
            v-if="mask"
            id="mask"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <path
              id="Combined-Shape"
              d="M135.922257,3.14948303 L92.4235131,56.6629037 C92.5762784,56.8591737 92.7324376,57.0613674 92.8921241,57.2697003 C96.2373923,63.8665145 98.5620378,70.9707767 99.7686102,78.5824869 L99.834593,79.0181556 L99.846593,79.0971556 L99.8346309,79.0173891 L99.849823,79.1084821 L99.849823,79.1084821 L99.869593,79.2441556 L99.9028626,79.4630131 C99.9134343,79.5603236 99.9258102,79.6595981 99.9375677,79.7603214 C100.141581,81.5080462 100.33943,83.2201278 100.41581,84.8724979 L125.333899,68.4434226 C124.319997,70.3224016 122.338979,73.5265395 119.156992,76.3215968 C97.7709254,95.1071217 80.8436174,103.971788 68.3750683,102.915595 C60.6531139,103.569439 51.2208942,100.418087 40.0784706,93.4615562 L14.3996032,72.9600993 C12.6967611,70.8305581 11.6134546,68.8510999 11.0521147,67.7452965 L10.7566309,66.6173891 L39.9886566,85.8916075 C40.0072308,83.8795692 40.2325668,81.8049466 40.4712376,79.7603214 L40.5086841,79.4630131 L40.5386877,79.2442966 L40.538593,79.2411556 L40.5605876,79.0980446 L40.579593,78.9731556 L40.6401952,78.5824869 C41.6387399,72.2831276 43.4030548,66.3313204 45.8779035,60.7270651 L0.153587076,4.47318164 C0.0978253257,3.64121161 0.0570841659,2.80513722 0.0316308956,1.96522606 L47.711593,57.0161556 L47.7724342,56.9373751 C51.984206,51.4870883 53.6746104,50.43178 55.4764513,49.5233673 C62.3958522,45.9664868 67.2501644,44.2846824 70.2047643,44.4779541 L70.3807374,44.4687232 C73.3490076,44.3515932 78.1470279,46.0364746 84.932354,49.5233673 C86.3154109,50.2206466 87.6328118,51.0044738 90.0752208,53.7960098 L135.9941,0.77839133 C135.983727,1.57211595 135.959705,2.36255424 135.922257,3.14948303 Z"
              fill="#00ADC1"
            />
            <g id="Combined-Shape-Copy-127">
              <use
                fill="url(#radialGradient-1)"
                fill-rule="evenodd"
                xlink:href="#path-2"
              />
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-3)"
                xlink:href="#path-2"
              />
              <use stroke="#EEEEEE" stroke-width="1" xlink:href="#path-2" />
            </g>
          </g>
        </g>
        <!-- hair front -->
        <frontHair
          :hairStyle="hairStyleF"
          :class="`avatar__hair--${hairColor}`"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import frontHair from "./av-front-hair.vue";
import backHair from "./av-back-hair.vue";
import faceColors from "./av-face-colors.vue";

export default {
  components: {
    frontHair,
    backHair,
    faceColors
  },
  props: {
    avatarAttributes: {
      type: Object,
      default: null
    },
    avatarId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      skinTone: this.avatarAttributes?.skinTone || "white",
      hairStyleF: this.avatarAttributes?.hairStyle || "black",
      hairStyleB: this.avatarAttributes?.hairStyle || "black",
      hairColor: this.avatarAttributes?.hairColor || "black",
      mask: this.avatarAttributes?.mask || false
    };
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 100%;
  height: 100%;
}

.avatar-wrapper {
}

.avatar__eye {
  fill: rgb(57, 41, 41);
}
.avatar__hair {
  &--brown {
    fill: brown;
    &.back {
      fill: rgb(126, 24, 24);
    }
  }
  &--black {
    fill: rgb(12, 1, 1);
    &.back {
      fill: rgb(5, 1, 1);
    }
  }
  &--gray {
    fill: rgb(238, 237, 237);
    &.back {
      fill: rgb(206, 204, 204);
    }
  }
  &--white {
    fill: rgb(194, 194, 194);
    &.back {
      fill: rgb(139, 133, 133);
    }
  }
  &--blond {
    fill: rgb(237, 179, 72);
    &.back {
      fill: rgb(213, 146, 22);
    }
  }
}

.avatar__shirt {
  fill: var(--yed-messageList-bg, white);
}
.avatar__nose-shadow {
  fill: rgb(105, 27, 9);
}
</style>
